export default __webpack_public_path__ + "static/media/ic_expand.226eca93.svg";